import React, { useState } from "react";

import { useMutation } from "react-apollo";

import { Field, Control, Input, Icon, Button } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { LOGON_USER_MUTATION } from "../../graphql/Users/Users.graphql";

import { ourToast as toast } from "../../utils";

import Copyright from "../../components/Copyright";

import "./LoginPage.scss";

export const update = (cache, { data: { logOnUser } }) => {
  localStorage.setItem("user_key", logOnUser.UserInfo.UserKey);
  localStorage.setItem("token", logOnUser.access_token);
  localStorage.setItem("user_company", logOnUser.UserInfo.UserKey);
  cache.writeData({
    data: {
      authStatus: {
        __typename: "authStatus",
        status: "loggedIn",
        company: logOnUser.UserInfo.UserKey
      }
    }
  });
  toast.success(`Welcome, ${logOnUser.UserInfo.FirstName}!`);
};

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [login, { loading }] = useMutation(LOGON_USER_MUTATION, {
    variables: {
      data: { username, password }
    },
    update,
    refetchQueries: ["CURRENT_USER_QUERY"]
  });

  const handleSubmit = async e => {
    e.preventDefault();
    await login();
  };

  return (
    <main id="login-page">
      {/* <Login /> */}
      <div className="login-form">
        <form id="login-form" method="POST" onSubmit={handleSubmit}>
          <h1 className="title" style={{ width: 400, lineHeight: 1.6 }}>
            Transgas Management Software
          </h1>
          <fieldset aria-busy={loading} disabled={loading}>
            <Field>
              <Control iconLeft iconRight>
                <Input
                  required
                  autoComplete="username"
                  disabled={loading}
                  id="username"
                  label="Username"
                  name="username"
                  placeholder="Username"
                  size="medium"
                  type="text"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                />
                <Icon align="left">
                  <FontAwesomeIcon icon="user" />
                </Icon>
                <Icon align="right">
                  <FontAwesomeIcon icon="check" />
                </Icon>
              </Control>
            </Field>
            <Field>
              <Control iconLeft>
                <Input
                  required
                  autoComplete="password"
                  disabled={loading}
                  id="password"
                  name="password"
                  placeholder="Password"
                  size="medium"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
                <Icon align="left">
                  <FontAwesomeIcon icon="lock" />
                </Icon>
              </Control>
            </Field>
            <Field>
              <Control expanded>
                <Button
                  className="button"
                  role="button"
                  size="medium"
                  state={loading ? "loading" : ""}
                  type="submit"
                >
                  Sign In
                </Button>
              </Control>
            </Field>
            <Copyright />
          </fieldset>
        </form>
      </div>
    </main>
  );
}

export default LoginPage;
